import React from 'react';
import ReactDOM from 'react-dom';
import AuthCheck from './components/AuthComponents/AuthCheck'
import App from './App';
import { registerWebPlugin } from "@capacitor/core";
import { OAuth2Client } from '@byteowls/capacitor-oauth2'
import ReduxInitializer from './components/ReduxInitializer';
import { setupIonicReact } from '@ionic/react';

// Ionic 6 dropped implicit initialization; this must run before anything calls
// isPlatform() or renders an Ionic component.
setupIonicReact();

registerWebPlugin(OAuth2Client)

ReactDOM.render(<AuthCheck><ReduxInitializer><App/></ReduxInitializer></AuthCheck>, document.getElementById('root'));

// The app has never shipped a service worker, but older builds registered one.
// Tear down any stale registration so cached assets cannot pin users to an old
// bundle.
if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
        .then((registration) => registration.unregister())
        .catch(() => {});
}
